module.exports = __webpack_public_path__ + "img/01-1大banner01.45b14ffa.png";